<template>
  <Card class="p-5">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </template>

      <InfoBox v-if="vmData.status != 'halted'">
        <div class="d-flex align-items-start justify-content-between">
          <span class="mr-3" style="max-width: 500px">{{
            $t('forms.vm.vmHaltedInfoMessage')
          }}</span>
          <ServerActionButton
            class="button danger"
            style="min-width: 120px"
            id="vm-stop"
            @click.native="runAction('shutdown', null, 'vm-stop')"
            :disabled="isDisableStop"
            :error="error"
          >
            <i class="fas fa-pause"></i>
            <span class="mr-1">{{ $t('detail.stop') }}</span>
          </ServerActionButton>
        </div>
      </InfoBox>

      <div :disabled="vmData.status != 'halted'">
        <CpuRamCluster v-if="vmData != '' && !isFarm" :vmData="vmData" />

        <CpuRamFarm
          v-if="vmData != '' && isFarm"
          :vmData="vmData"
          :catalogList="productCatalog"
        />
      </div>
    </b-skeleton-wrapper>
  </Card>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'

// Tools
import CpuRamCluster from '@/components/compute/virtualMachines/tabs/hardware/CpuRamCluster'
import CpuRamFarm from '@/components/compute/virtualMachines/tabs/hardware/CpuRamFarm'
import ServerActionButton from '@/components/buttons/ServerActionButton'

export default {
  name: 'CpuRam',
  data() {
    return {
      loading: false,
      vmData: '',
      isFarm: false,
      productCatalog: [],
      error: 'It is a long established fact that a reader will be.',
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getVmDetail()
  },
  computed: {
    isDisableStop() {
      return (
        this.vmData.status != 'running' ||
        this.vmData.domain_type == 'HVM' ||
        this.vmData.status == 'processing' ||
        this.vmData.status == 'preparing'
      )
    },
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  methods: {
    //Vm detail:begin
    getVmDetail() {
      this.loading = true
      this.getVmDetailInfo()
        .then((res) => {
          this.vmData = res.data

          this.isFarm = !(
            res.data.datacenterNode &&
            res.data.datacenterNode.data &&
            res.data.datacenterNode.data.pricing_model == 'resource'
          )

          if (this.isFarm) {
            this.getProductCatalogs()
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getVmDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(
          `iaas/virtual-machines/${this.getVmId}?include=datacenterNode`
        )
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //Vm detail:end

    // Product catalog:begin
    getProductCatalogs() {
      let productId =
        this.vmData &&
        this.vmData.datacenterNode &&
        this.vmData.datacenterNode.data
          ? this.vmData.datacenterNode.data.product_id
          : ''

      if (productId == '') {
        this.catalogList = [{ id: '', name: this.$t('global.pleaseSelect') }]
      } else {
        this.getProductCatalogList(productId)
          .then((res) => {
            this.setProductCatalogList(res)
          })
          .catch(() => {
            this.catalogList = [
              { id: '', name: this.$t('global.pleaseSelect') },
            ]
          })
      }
    },
    getProductCatalogList(productId) {
      return new Promise((resolve, reject) => {
        ApiService.get(
          `marketplace/${productId}/catalogs?page=1&start=0&limit=25&position=id|desc`
        )
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setProductCatalogList(res) {
      if (res && res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          let newName = item.name

          if (item.args) {
            newName += ' ('
            if (item.args.cpu) newName += `${item.args.cpu} CPU, `
            if (item.args.ram)
              newName += `${this.$customFunctions.convertMBtoGB(
                item.args.ram
              )} GB RAM, `
            if (item.args.disk)
              newName += `${this.$customFunctions.convertMBtoGBWithHalfPoint(
                item.args.disk
              )} GB DISK`
            newName += ')'
          }

          item.name = newName
        })
        this.productCatalog = res.data
      }
      this.productCatalog.unshift({
        id: '',
        name: this.$t('global.pleaseSelect'),
      })
    },
    // Product catalog:end
    runAction(action, params, idName) {
      EventBus.$emit('clickVmStopButton', { action, params, idName })
    },
  },
  components: {
    CpuRamCluster,
    CpuRamFarm,
    ServerActionButton,
  },
}
</script>
